import React from 'react'
import { string, object, array } from 'prop-types'
import { EventSteps } from '@/component/Primitive/Events'
import createButtonGroup from '../lib/button-group-creator'

const EventStepsWidget = ({ pageData, steps, ...other }) => {
  // Process button groups for each step
  const processedSteps =
    steps?.map((step) => ({
      ...step,
      buttonGroup: createButtonGroup(pageData, step.buttonGroup)
    })) || []

  return <EventSteps {...other} steps={processedSteps} />
}

EventStepsWidget.propTypes = {
  title: string,
  description: string,
  theme: string,
  steps: array,
  pageData: object
}

export default EventStepsWidget
